import React from 'react';
import { Flame } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-zinc-900/50 to-zinc-950" data-id="element-154">
      <div className="max-w-4xl mx-auto text-center" data-id="element-155">
        <div className="inline-flex items-center gap-2 md:gap-3 px-4 md:px-6 py-2 md:py-3 rounded-full bg-red-500/20 border border-red-500/50 text-red-400 font-bold text-sm md:text-xl mb-6 md:mb-8" data-id="element-156">
          <Flame className="w-4 h-4 md:w-6 md:h-6" data-id="element-157" />
          <span data-id="element-158">Promoción por tiempo limitado</span>
          <Flame className="w-4 h-4 md:w-6 md:h-6" data-id="element-159" />
        </div>

        <h3 className="text-2xl md:text-4xl font-bold text-white mb-4 md:mb-6" data-id="element-160">
          Cupos disponibles agotándose
        </h3>

        <div className="max-w-2xl mx-auto mb-4 md:mb-6" data-id="element-161">
          <div className="bg-zinc-800 rounded-full h-7 md:h-8 overflow-hidden relative" data-id="element-162">
            <div className="absolute inset-y-0 left-0 bg-gradient-to-r from-[#ff2e92] to-[#00b8ff] rounded-full" style={{
            width: '80%'
          }} data-id="element-163"></div>
            <div className="absolute inset-0 flex items-center justify-center text-white font-bold text-xs md:text-sm" data-id="element-164">
              80% tomados
            </div>
          </div>
        </div>

        <p className="text-base md:text-xl text-zinc-400" data-id="element-165">
          Últimos cupos a precio promocional — una vez agotados, vuelve al
          precio original.
        </p>
      </div>
    </section>;
}